module.exports = __webpack_public_path__ + "media/newstyle/images/icon-open-quote-bfebef0f8025c5ee9676f767cbf5f88e.svg";